import {type LayoutType} from '@wandb/weave/common/types/media';

import {type LayoutMode} from './common';

// Global configurable
export const MAX_COL_COUNT = 20;
export const MIN_COL_COUNT = 1;
export const MAX_COMPARE_COL_COUNT = 4;
export const MIN_COMPARE_COL_COUNT = 2;
export const MAX_RUNS_PERF_WARNING_THRESHOLD = 150;
export const DEFAULT_MAX_Y_AXIS_COUNT = 30;
export const DEFAULT_LAYOUT_TYPE: LayoutType = 'ALL_STACKED';

export const MAXIMUM_MEDIA_PANEL_IMAGE_COUNT = 32;
export const DEFAULT_COLUMN_COUNT = 3;

/**
 * Default column count for gallery/grid/compare when `columnCount` is unset.
 * Gallery/grid cap at {@link DEFAULT_COLUMN_COUNT} but shrink when the active
 * axis has fewer values (e.g. one index → one column).
 */
export function defaultColumnCount(
  mode?: LayoutMode,
  axisValueCount?: number
): number {
  if (mode === 'compare') {
    return 2;
  }
  if (axisValueCount == null || axisValueCount < 1) {
    return DEFAULT_COLUMN_COUNT;
  }
  return Math.min(axisValueCount, DEFAULT_COLUMN_COUNT);
}
